import React from 'react'

import Breadcrumb from 'components/Breadcrumb'

import PropTypes from 'prop-types'

import Content from 'components/ContentDetail'
import Loading from 'components/Loading'

import Feedback from './Feedback'
import PageTitle from './PageTitle'
import PitchReference from './PitchReference'

const Pitch = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <div className="portlet-body">
      <div className="table-scrollable table-scrollable-borderless">
        <Content title="Pitch" data={props.content} />
        <Feedback />
        <PitchReference />
      </div>
    </div>
  </div>
)

Pitch.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  content: PropTypes.arrayOf(PropTypes.array).isRequired,
}


export default Pitch
